import { render, staticRenderFns } from "./UserThreads.vue?vue&type=template&id=1a733710&scoped=true&"
import script from "./UserThreads.vue?vue&type=script&lang=js&"
export * from "./UserThreads.vue?vue&type=script&lang=js&"
import style0 from "./UserThreads.vue?vue&type=style&index=0&id=1a733710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a733710",
  null
  
)

export default component.exports